<template>
  <button
    class="purchase-btn"
    :class="{
      'purchase-arrow': isArrow,
      'is-mini': isMini,
      disabled: disabled,
    }"
    :disabled="disabled"
    @click.stop="handleSquareBtnClick"
  >
    <span v-if="isShine" class="shine-effect"></span>
    {{ localizedText }}
  </button>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  name: 'BuyButton',
  mixins: [t],

  props: {
    text: {
      type: String,
      default: null,
    },
    isArrow: {
      type: Boolean,
      default: true,
    },
    isShine: {
      type: Boolean,
      default: false,
    },
    isMini: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    localizedText() {
      return this.text || this.t('購入');
    },
  },

  methods: {
    handleSquareBtnClick() {
      if (!this.disabled) {
        this.$emit('handleSquareBtnClick');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.purchase-btn {
  background: linear-gradient(to top, #2a70b8, #2c7abf, #2d9dd9, #70c7d6);
  color: white;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  padding: 10px 25px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s ease;
  position: relative;
  justify-content: center;
  overflow: hidden; // 光がはみ出ないようにする
  &.is-mini {
    padding: 5px 15px;
    font-size: 12px;
    line-height: 1.2;
    @media screen and (max-width: $tabletWidth) {
      font-size: 11px;
    }
  }
  &.disabled {
    background: #ccc;
    color: #777;
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.6;
    pointer-events: none;
  }
  // 光のエフェクトを別レイヤーに配置
  .shine-effect {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100px;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    opacity: 0.6;
    transform: skewX(-20deg); // 斜めの光線効果
    animation: shine 2s infinite linear;
  }
}

.purchase-arrow {
  position: relative; // 光の影響を受けないようにする
}

.purchase-arrow::after,
.purchase-arrow::before {
  content: '';
  display: block;
  width: 2px;
  height: 10px;
  background-color: white;
  position: absolute;
  right: 8px;
  transform-origin: center;
}
.purchase-arrow::before {
  transform: rotate(45deg);
  top: 48%;
  margin-top: -2px;
}
.purchase-arrow::after {
  transform: rotate(-45deg);
  top: 52%;
  margin-top: -10px;
}

@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@media screen and (max-width: $tabletWidth) {
  .purchase-btn {
    padding: 5px 15px;
    font-size: 10px;
  }
  .purchase-arrow::after,
  .purchase-arrow::before {
    width: 2px;
    height: 8px;
    right: 8px;
  }
  .purchase-arrow::before {
    margin-top: -2px;
  }
  .purchase-arrow::after {
    margin-top: -6px;
  }
}
</style>
